import { HubSpotProps } from './types';
import { HubSpotVariants } from './constants';
import HubSpotBaseVariant from './HubSpotBaseVariant';
import HubSpotFeaturedVariant from './HubSpotFeaturedVariant';

const HubSpot = (props: HubSpotProps) => {
  const { variant } = props;

  switch (variant) {
    case HubSpotVariants.Featured:
      return <HubSpotFeaturedVariant {...props} />;
    case HubSpotVariants.Base:
    default:
      return <HubSpotBaseVariant {...props} />;
  }
};

export default HubSpot;
